module.exports = __webpack_public_path__ + "img/logo-shiba888.a498a602.png";